import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import routes from "../../../../../routes";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schemaGenerator from "../../../../schemas/schemaGeneratorLabReportUpload";
import { Button, notification, PageHeader, Spin } from "antd";
import LabReportUploadForm from "../../../../forms/LabReportUploadForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sliceKey, reducer, actions } from "./slice";
import { actions as orderListActions } from "../OrderListing/slice";
import { labReportReUploadSaga } from "./sagas";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import * as selectors from "./selectors";
import { reverse } from "named-urls";

/* const keyParameters = [
  {
    name: "Microbial Fungus",
    minOperationalValue: 10,
    maxOperationalValue: 20,
  },
  {
    name: "Aflatoxin B1",
    minOperationalValue: 1,
    maxOperationalValue: 2,
  },
  {
    name: "Lead",
    minOperationalValue: 50,
    maxOperationalValue: 60,
  },
]; */

function toCamelCase(str) {
  // Split the string by spaces, hyphens, or underscores
  const words = str.split(/[\s-_]+/);

  // Transform the first word to lowercase
  let camelCaseStr = words[0].toLowerCase();

  // Capitalize the first letter of each subsequent word and concatenate them
  for (let i = 1; i < words.length; i++) {
    camelCaseStr += words[i][0].toUpperCase() + words[i].slice(1).toLowerCase();
  }

  return camelCaseStr;
}

const defaultObjectForReactHookForm = (keyParameters) => {
  let requiredObj = {};
  if (keyParameters.length) {
    keyParameters.forEach((key) => {
      let camelCaseString = toCamelCase(key.parameter);
      requiredObj[`${camelCaseString}`] = "";
    });
    return requiredObj;
  }
};

function dataToGenerateForm(keyParameters) {
  let requiredArray = [];
  for (let i = 0; i < keyParameters.length; i += 2) {
    let arrayOfParameters = [];
    arrayOfParameters.push(keyParameters[i]);
    if (i + 1 < keyParameters.length)
      arrayOfParameters.push(keyParameters[i + 1]);
    requiredArray.push(arrayOfParameters);
  }
  return requiredArray;
}

const ReUploadReport = () => {
  const { orderId } = useParams();
  const id = orderId;

  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: labReportReUploadSaga });

  const dispatch = useDispatch();
  const history = useHistory();
  //history.push(routes.labs.dashboard);

  useEffect(() => {
    dispatch(actions.fetchOrderDetails(id));
    return () => {
      dispatch(actions.initializeState());
    }
  }, [dispatch, id]);

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  const [loaderWhileSaving, setLoaderWhileSaving] = useState(false);
  const orderDetails = useSelector(selectors.selectOrderDetails) || null;

  let labResultsUploaded = null;

  let keyParameters = orderDetails
    ? orderDetails.packages[0].package.keyParameters
    : [];

  // let schema = null;
  // let dataForForm = [];
  // if (keyParameters.length) {
  //   //console.log(defaultObjectForReactHookForm(keyParameters));
  //   keyParameters = keyParameters.map((obj) => {
  //     return {
  //       ...obj,
  //       key: toCamelCase(obj.parameter),
  //     };
  //   });
  //   //console.log(keyParameters);
  //   schema = schemaGenerator(keyParameters, orderDetails.sampleVariant);
  //   dataForForm = dataToGenerateForm(keyParameters);
  // }
  //console.log(orderDetails);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      labReport: "",
      labReportMetadata: "",
      overallSafetyCompliant: "",
      overallQualityCompliant: "",
      overallLabellingCompliant:
        orderDetails?.sampleVariant === "Loose" ? "NA" : "",
      overallSampleClassification: "",
      // ...defaultObjectForReactHookForm(keyParameters),
    },
    resolver: yupResolver(schemaGenerator(orderDetails?.sampleVariant)),
  });

  useEffect(() => {
    labResultsUploaded = {
      labReport: orderDetails?.labResponseId?.reportFile,
      labReportMetadata: orderDetails?.labResponseId?.reportMetadataFile,
      overallSafetyCompliant:
        orderDetails?.labResponseId?.overallSafetyCompliant,
      overallQualityCompliant:
        orderDetails?.labResponseId?.overallQualityCompliant,
      overallLabellingCompliant:
        orderDetails?.labResponseId?.overallLabellingCompliant,
      overallSampleClassification:
        orderDetails?.labResponseId?.overallSampleClassification,
    };

    // orderDetails?.labResponseId?.keyParametersValues.forEach((obj) => {
    //   labResultsUploaded[toCamelCase(obj.parameter)] = obj.parameterValue;
    // });

    if (labResultsUploaded) reset(labResultsUploaded);
  }, [reset, orderDetails, labResultsUploaded]);

  let disableFields = {
    overallLabellingCompliant:
      orderDetails?.sampleVariant === "Loose" ? true : false,
  };

  const onSubmit = (data) => {


    // let keyParametersValues = [];
    // Object.keys(data).forEach((key) => {
    //   if (key !== "labReport" && key !== "labReportMetadata") {
    //     let requiredParameter = keyParameters.filter((keyParameter) => {
    //       if (keyParameter.key === key) return keyParameter;
    //     });
    //     if (requiredParameter.length) {
    //       let requiredObj = {
    //         parameter: requiredParameter[0].parameter,
    //         parameterValue: data[`${key}`],
    //       };
    //       keyParametersValues.push(requiredObj);
    //     }
    //   }
    // });

    let payload = {
      labReport: data.labReport,
      labReportMetadata: data.labReportMetadata,
      orderId: orderDetails.orderId,
      overallSafetyCompliant: data.overallSafetyCompliant,
      overallQualityCompliant: data.overallQualityCompliant,
      overallLabellingCompliant: data.overallLabellingCompliant,
      overallSampleClassification: data.overallSampleClassification,
      id,
      orderDetails,
      // keyParametersValues,
      onSuccess: () => {
        notification.success({
          message: "Report Uploaded Successfully!!!",
        });

        if (orderDetails?.status?.value === "underDispute") {
          const requestCorrections =
            orderDetails?.underDispute?.at(-1)?.requestCorrections;
          const allCorrectionsResolved = requestCorrections.every(
            (correction) =>
              correction.type === "report" || correction.isResolved === true
          );
          if (allCorrectionsResolved) {
            // All corrections are resolved
            dispatch(orderListActions.setActiveNavOption("REPORT UPLOADED"));
          }
        }

        // history.push(reverse(`${routes.labs}`));
        history.goBack();
        setLoaderWhileSaving(false);
      },
      onFailure: () => {
        notification.error({
          message: "Error Saving Response!",
          description: error,
        });
        setLoaderWhileSaving(false);
      },
    };
    setLoaderWhileSaving(true);
    dispatch(actions.updateReport(payload));
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title="Lab Results Update Form"
        subTitle={
          orderDetails
            ? `${orderDetails.orderId},  ${orderDetails.sampleVariant} Variant`
            : ""
        }
        extra={[
          <Button key="1" onClick={() => history.goBack()}>
            Back
          </Button>,
          <Button
            disabled={loading || loaderWhileSaving ? true : false}
            loading={loading || loaderWhileSaving ? true : false}
            key="2"
            type="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh) - 50px",
          padding: "24px",
          backgroundColor: "#ffffff",
          marginTop: "20px",
        }}
      >
        {loading || loaderWhileSaving ? (
          <Spin
            size="large"
            style={{
              height: "calc(80vh)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        ) : (
          <LabReportUploadForm
            // keyParameters={dataForForm}
            control={control}
            setValue={setValue}
            watch={watch}
            errors={errors}
            options={{ disableFields }}
          />
        )}
      </div>
    </>
  );
};

export default ReUploadReport;
